define(function (require) {

    window.lpTag = window.lpTag || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    var TimerManager = function () {

        var logger = WebAgentLogger.getLogger("TimerManager");
        var timerRegisterList = {};
        var registeredCount = 0;
        var totalCount = 0;
        var timerIsRunning = false;
        var currentTimeout;
        var TIME_STEP_IN_SEC = 1;
        var PROPERTY_NAMES = {
            CURRENT_INTERVAL: 'currentInterval',
            NUM_OF_CALLS: 'numOfCalls'
        };
        var that = this;

        this.registerTimer = function (registerToTimerObject) {

            var callback = registerToTimerObject.callback;
            var context = registerToTimerObject.context;
            var timerInterval;
            var numOfCalls;

            if (!context || !callback || typeof callback !== 'function') {
                logger.error("Could not register to timer. check parameters", "registerTimer");
                return;
            }

            timerInterval = registerToTimerObject.interval || TIME_STEP_IN_SEC;

            if (registerToTimerObject.numOfCalls) {
                numOfCalls = registerToTimerObject.numOfCalls;
            }

            var registerUniqueId = singleRegisterTimer(context, callback, timerInterval, numOfCalls);
            startTimer();
            return registerUniqueId;
        };

        function singleRegisterTimer(context, callback, timerInterval, numOfCalls) {
            var uniqueRegistrationId = new Date().getTime() + '.' + totalCount;
            timerRegisterList[uniqueRegistrationId] = {context: context, callback: callback, timerInterval: timerInterval, currentInterval: timerInterval, numOfCalls: numOfCalls, id:uniqueRegistrationId};
            registeredCount++;
            totalCount++;
            return uniqueRegistrationId;
        }

        function isRegisterListEmpty() {
            if (registeredCount < 0) {
                registeredCount = 0;
            }
            return registeredCount === 0;
        }

        function checkIfTimerShouldStop() {
            if (timerIsRunning && isRegisterListEmpty()) {
                stopTimer();
            }
        }

        function startTimer() {
            if (!timerIsRunning) {
                timerIsRunning = true;
                wakeUpTimer();
            }
        }

        function stopTimer() {
            if (timerIsRunning) {
                timerIsRunning = false;
                clearCurrentTimeout();
            }
        }

        function clearCurrentTimeout() {
            if (currentTimeout) {
                clearTimeout(currentTimeout);
                currentTimeout = null;
            }
        }

        function wakeUpTimer() {
            clearCurrentTimeout();
            if (timerIsRunning) {
                currentTimeout = setTimeout(wakeUpTimer, TIME_STEP_IN_SEC * 1000);
                runAllCallbacks();
            }
        }

        function copyRegisteredList() {
            var newList = {};
            for (var key in timerRegisterList) {
                if (timerRegisterList.hasOwnProperty(key)) {
                    newList[key] = copySingleItem(timerRegisterList[key]);
                }
            }
            return newList;
        }

        function copySingleItem(item) {
            var newItem = {};
            for (var prop in item) {
                if (item.hasOwnProperty(prop)) {
                    newItem[prop] = item[prop];
                }
            }
            return newItem;
        }

        function runAllCallbacks() {
            var listToRunOn = copyRegisteredList();
            for (var key in listToRunOn) {
                if (listToRunOn.hasOwnProperty(key)) {
                    var timedObj = listToRunOn[key];
                    if (timedObj && (typeof timedObj.numOfCalls === 'undefined' || timedObj.numOfCalls > 0)) {
                        checkIntervalAndRunCallback(timedObj);
                    } else {
                        // if the number if calls is defined and is equal to zero - the key has expired, so we unregister it
                        that.unregisterTimer({uniqueId: key});
                    }
                }
            }
        }

        function checkIntervalAndRunCallback(timedObj) {
            if (timedObj && !isNaN(timedObj.timerInterval) && !isNaN(timedObj.currentInterval)) {
                // The timer is up when we reach the time step size - because it's not zero based
                if (timedObj.currentInterval <= TIME_STEP_IN_SEC) {
                    // if the current interval has reached zero - we reset the current interval and run the callback
                    setPropertyOnTimedObj(timedObj, PROPERTY_NAMES.CURRENT_INTERVAL, timedObj.timerInterval);
                    runCallback(timedObj);
                } else {
                    // we only count down on the current interval
                    setPropertyOnTimedObj(timedObj, PROPERTY_NAMES.CURRENT_INTERVAL, timedObj.currentInterval - TIME_STEP_IN_SEC);
                }
            }
        }

        function setPropertyOnTimedObj(timedObj, name, value) {
            timedObj[name] = value;
            if (timedObj && timedObj.id && timerRegisterList[timedObj.id]) {
                timerRegisterList[timedObj.id][name] = value;
            }
        }

        function runCallback(timedObj) {
            // decrease the number of calls left
            if (!isNaN(timedObj.numOfCalls)) {
                setPropertyOnTimedObj(timedObj, PROPERTY_NAMES.NUM_OF_CALLS, timedObj.numOfCalls - 1);
            }
            // Call the callback
            try {
                timedObj.callback.call(timedObj.context, {callsLeft: timedObj.numOfCalls, interval: timedObj.timerInterval, isLastCall: timedObj.numOfCalls <= 0});
            }
            catch (err) {
                logger.error('Could not run the specified callback', err);
            }
        }

        this.unregisterTimer = function (unregisterObject) {
            if (unregisterObject.uniqueId) {
                if (timerRegisterList && timerRegisterList[unregisterObject.uniqueId]) {
                    timerRegisterList[unregisterObject.uniqueId] = null;
                    delete timerRegisterList[unregisterObject.uniqueId];
                    registeredCount--;
                }
            }
            // if a unique ID wasn't specified - we unregister according to context/callback
            else if (unregisterObject.context) {
                for (var key in timerRegisterList) {
                    if (timerRegisterList[key].context === unregisterObject.context) {
                        if (!unregisterObject.callback || timerRegisterList[key].callback === unregisterObject.callback) {
                            timerRegisterList[key] = null;
                            delete timerRegisterList[key];
                            registeredCount--;
                        }
                    }
                }
            }
            checkIfTimerShouldStop();
        };
    };

    return TimerManager;

});
